let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("liq6J")).then(() => parcelRequire('joiX4'));